import { chatStore } from '@/store/chatStore';
import { copyText } from '@/lib/utils';
import bus from '@/lib/bus';

import {
  getMsgInfoById,
  addFavoritesFromMsg,
  recallMsg,
  toText,
  topMsg,
  getChatInfoById,
  cancelTopMsg,
  markMsg,
  tagMsg,
  translateMsg,
  translateCantoneseMsg,
} from '@/lib/helpers/chat';
interface TargetInterface {
  targetItem: string;
  targetItemType?: string;
  targetItemId: string;
  tagItemId?: string;
}
const map: {
  [key: string]: {
    [key: string]: (targetInfo: TargetInterface) => void;
  };
} = {
  recall: {
    'msg-item': ({ targetItemId }) => {
      recallMsg(targetItemId);
    },
  },
  copy: {
    'msg-item': ({ targetItemId }) => {
      const res = getMsgInfoById(targetItemId);
      res.data?.type == 1 ? copyText(res.data?.text) : copyText(res.data?.img_url);
    },
  },
  quote: {
    'msg-item': ({ targetItemType, targetItemId }) => {
      const chatStoreEx = chatStore();
      const res = getMsgInfoById(targetItemId);
      chatStoreEx.setCurrentQuoteInfo(targetItemType, res?.data?.text || res?.data?.img_url, targetItemId);
    },
  },
  translation: {
    'msg-item': ({ targetItemId }) => {
      translateMsg(targetItemId);
    },
  },
  translationCantonese: {
    'msg-item': ({ targetItemId }) => {
      translateCantoneseMsg(targetItemId);
    },
  },
  'at-user': {
    'avatar-item': ({ targetItemId }) => {
      bus.emit('addAtUser', targetItemId);
    },
  },
  'top-chat-item': {
    'chat-item': ({ targetItem, targetItemType, targetItemId }) => {
      const res = getChatInfoById(targetItemId);
      if (targetItemId && res.source) {
        if (res.is_top) {
          cancelTopMsg(Number(targetItemId), res.source);
        } else {
          topMsg(Number(targetItemId), res.source);
        }
      }
    },
  },
  'mark-chat-item': {
    'chat-item': ({ targetItemId }) => {
      const chatStoreEx = chatStore();
      const res = getChatInfoById(targetItemId, chatStoreEx.currentActiveChatListFrom);
      if (targetItemId && res.source) {
        markMsg(res);
      }
    },
  },
  'tag-chat-item': {
    'chat-item': ({ targetItemId, tagItemId }) => {
      const chatStoreEx = chatStore();
      const res = getChatInfoById(targetItemId, chatStoreEx.currentActiveChatListFrom);
      let type = res.labels?.findIndex((v) => v.id == tagItemId) === -1 ? 'bind' : 'unbind';
      tagMsg({
        relate_type: type,
        receive_label_id: Number(tagItemId),
        receive_id: Number(targetItemId),
      });
    },
  },
  'delete-chat-item': {
    'chat-item': ({ targetItemId }) => { },
  },
  paste: {},
  collect: {
    'msg-item': ({ targetItemType, targetItemId }) => {
      const res = getMsgInfoById(targetItemId);
      addFavoritesFromMsg(res);
    },
  },
  toText: {
    'msg-item': ({ targetItemType, targetItemId }) => {
      toText(Number(targetItemId));
    },
  },
};

export default map;
